import React from "react";
import { ErrorCommon, TextField, TextFieldCommon } from "../../../components/formikFormInputs";
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { Label } from "../../formInputs";
import { useFormikContext } from "formik";
import { usePolicyContext } from "./PolicyContext";
import UploadVoidedCheck from "./UploadVoidedCheck";
import selectField from "../../formikFormInputs/SelectField";
import InfoIcon from "@material-ui/icons/Info";
import {isAdmin} from "../../navigation/AdminNavigation";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers";

function BankAccountDetails() {
    const { values, handleChange, handleBlur, errors, touched } = useFormikContext();
    const { policy }: any = usePolicyContext();
    const [bankAccount, setBankAccount] = React.useState<any>([]);
    const {user} = useSelector((state: RootState) => state.auth);
    const isServicing = user && user.accessType === "client" && user.demoClientId
    const disabled = isAdmin(user) || !!isServicing
    const bankAccountType = [
        { key: "PersonalChecking",value: 'PersonalChecking', name: 'Checking' },
        { key:"PersonalSavings",value: 'PersonalSavings', name: 'Savings' },
    ];
    const bankDetailsFields = [
        {
            label: <Label label={"Bank Name"} required />,
            name: "bankName",
            placeholder: "Bank Name",
            id: "bankName",
            component: TextField,
            disabled: disabled,
        },
        {
            label: <Label label={"Bank Account Holder"} required />,
            name: "bankAccountHolder",
            placeholder: "Bank Account Holder",
            id: "payerLastName",
            component: TextField,
            disabled: disabled,
        },
        {
            label: <Label label={"Routing Number"} required />,
            name: "routingNumber",
            placeholder: "Routing Number",
            id: "routingNumber",
            component: TextField,
            disabled: disabled,
        },
        {
            label: <Label label={"Account Number"} required />,
            name: "accountNumber",
            placeholder: "Account Number",
            id: "accountNumber",
            component: TextField,
            disabled: disabled,
        },
        {
            label: <Label label={"Confirm Account Number"} required />,
            name: "confirmAccountNumber",
            placeholder: "Confirm Account Number",
            id: "confirmAccountNumber",
            component: TextField,
            disabled: disabled,
        },
        {
            label: <Label label={"Account Type"} required />,
            name: "bankAccountType",
            placeholder: "Account Type",
            component: selectField,
            options: bankAccountType,
            disabled: disabled,
        },

    ];

    return (

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <span className="hLine"/>
                    <Typography variant="body1" component="strong" className="floatLeft w100 mb0">Bank Account Details</Typography>
                </Grid>
                {
                    bankDetailsFields.map((field, index) => {
                        return (<Grid item xs={12} sm={12} md={6} key={index}>
                            <TextFieldCommon
                                    {...field}
                                    values={values}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                            />
                            {
                                field.name === "accountNumber" &&
                                    <Tooltip
                                             className="floatRight"
                                            color="primary"
                                            title={"If paying from a credit union, use your full account number, not your member number."} arrow>
                                        <IconButton aria-label="Info">
                                            <InfoIcon className="f16"/>
                                        </IconButton>
                                    </Tooltip>
                            }

                            <ErrorCommon errors={errors}
                                         name={field.name}
                                         touched={touched} />
                        </Grid>);
                    })
                }
                <span className="hLine"/>
                <UploadVoidedCheck />
            </Grid>
    );
}

export default BankAccountDetails;